<template>
  <section
    class="tw-w-full tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-purple-600 tw-px-3 tw-py-10">
    <div class="tw-max-w-xl tw-text-center tw-w-full">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        class="tw-w-12 md:tw-w-16 tw-flex tw-m-auto" viewBox="0 0 38.38 41.04">
        <defs>
          <linearGradient id="logo-gradient" x1="19.19" y1="41.04" x2="19.19" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#6819bc" />
            <stop offset="1" stop-color="#4f1087" />
          </linearGradient>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path class="logo-gradient" style="fill: #fff"
              d="M33.86,2.88C29.81,1.31,25.4,4,24.15,8c-.92,2.92-1.7,7.38-5.88,7-2.1-.17-3.38-1-3.89-3.07-.55-2.25.55-4.59-.69-7.42A7.73,7.73,0,0,0,9.27.35C5.18-1,1,1.85.17,5.91a8.28,8.28,0,0,0,1.4,6.45c1.34,2,3.06,4.73,2.81,7.13S2.23,23.2,1.52,25.4a5.25,5.25,0,0,0,1,5.16c2.68,3.17,8.3,2.86,10.43-.78A5.19,5.19,0,0,0,12.48,24c-1.32-1.68-4.23-2.3-5.13-4.4a4.4,4.4,0,0,1,1.83-5.1c1.65-1,4-.7,4.17,1.39.09,1.14-.63,1.64-.88,2.75a5.52,5.52,0,0,0,4.29,6.61c3.74.76,6.74-1.47,7.22-4.7.16-1.11-.35-3.65.7-4.33a2,2,0,0,1,3,2.07c-.28,2.86-2.43,5.6-4.33,7.5-2.4,2.41-5.6,4.74-5.48,8.44A6.91,6.91,0,0,0,25.52,41a9.25,9.25,0,0,0,7.85-9.18,7.79,7.79,0,0,0-2.06-5.05c-1.08-1.27-2-2.37-1.55-4,.66-2.36,3.07-4.69,4.93-6.19,2.91-2.32,4.58-5.83,3.2-9.53A7.11,7.11,0,0,0,33.86,2.88Z" />
          </g>
        </g>
      </svg>
      <h3 class="tw-font-sans tw-text-base md:tw-text-lg tw-text-white tw-font-black tw-tracking-wider tw-mt-5">
        ASSINAR MUSICPRO PREMIUM
      </h3>
      <v-form id="paymentForm" ref="paymentForm" v-model="form.valid" lazy-validation v-if="page == 1"
        class="tw-w-full tw-rounded-3xl tw-rounded-b-2xl tw-bg-gray-200 tw-mt-8 tw-shadow-lg">
        <div
          class="tw-flex tw-items-center tw-justify-between tw-w-full tw-border-b tw-border-gray-400 tw-py-5 tw-px-5 tw-bg-purple-400 tw-rounded-t-2xl">
          <h4
            class="tw-text-xs tw-tracking-widest tw-font-sans tw-text-white tw-opacity-60 tw-font-extrabold tw-uppercase">
            Finalizar Compra
          </h4>
        </div>
        <div id="summary" class="tw-flex tw-flex-col tw-w-full tw-px-5">
          <div class="tw-flex tw-items-center tw-justify-between item tw-w-ful tw-pt-5">
            <div class="tw-text-xs tw-tracking-widest tw-font-black tw-uppercase tw-font-sans tw-text-gray-700">
              Sumário
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-justify-between item tw-w-full tw-border-b tw-border-gray-400 tw-py-5">
            <div class="tw-text-base tw-font-sans tw-text-gray-800">
              {{ this.productName }}
            </div>
            <div v-if="!this.discount" class="tw-text-base tw-font-sans tw-text-gray-800">
              {{ this.displayPrice }}
            </div>
            <div v-if="this.discount" class="tw-text-base tw-font-sans tw-text-gray-800">
              <span class="tw-line-through tw-text-gray-600">{{
                this.displayPrice
}}</span>
              <span>{{ this.displayTotal }}</span>
            </div>
          </div>
          <v-list class="tw-w-full tw-bg-transparent tw-px-0" nav light>
            <v-list-group v-model="accordion.coupon" prepend-icon="mdi-sale" no-action>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="tw-text-left tw-font-sans tw-text-sm tw-font-semibold">Aplicar Cupom de
                    desconto?</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item class="tw-px-0">
                <v-list-item-content>
                  <div id="card-details" class="tw-flex tw-flex-col tw-w-full">
                    <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between item tw-w-full">
                      <div class="tw-flex tw-w-full tw-pr-2">
                        <v-text-field label="Digite o código do cupom" validate-on-blur data-checkout="cardholderName"
                          hint="Digite um cupom válido" type="text" id="cardholderName" v-model="couponInput" dense
                          light color="#4f1087" filled onselectstart="return false" onpaste="return false"
                          oncopy="return false" oncut="return false" ondrag="return false"
                          ondrop="return false"></v-text-field>
                      </div>
                      <div v-if="couponApplied === true" class="tw-text-xs tw-text-green-600 tw-mb-5">
                        Cupom aplicado com sucesso! 🥳
                      </div>
                      <div v-if="couponApplied === false" class="tw-text-xs tw-text-red-400 tw-mb-5">
                        Cupom expirado ou inválido!
                      </div>
                      <div class="tw-w-full tw-mb-5">
                        <v-btn depressed block color="#6819bc"
                          class="focus:tw-outline-none focus:tw-bg-purple-400 tw-font-sans tw-text-xs tw-text-white"
                          @click="applyCoupon()" id="form-checkout__submit" x-large>
                          Aplicar Cupom
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
          <div class="tw-flex tw-items-center tw-justify-between item tw-w-full tw-py-5">
            <div class="tw-text-xs tw-font-black tw-font-sans tw-text-gray-800 tw-opacity-50 tw-uppercase">
              Total
            </div>
            <div v-if="!this.discount" class="tw-text-base tw-font-sans tw-text-gray-800">
              {{ this.displayPrice }}
            </div>
            <div v-if="this.discount"
              class="tw-flex tw-flex-col tw-items-end tw-text-base tw-font-sans tw-text-gray-800">
              <small class="tw-text-gray-600">
                <span class="tw-text-xs">DESCONTO: </span>
                <span class="tw-line-through">{{ this.displayDiscount }}</span>
              </small>
              <span>{{ this.displayTotal }}</span>
            </div>
          </div>
        </div>
        <div id="buyer-details" class="tw-flex tw-flex-col tw-w-full tw-px-5 tw-mt-10">
          <div class="tw-flex tw-w-full">
            <v-autocomplete v-if="
              !Object.keys(currentUser).length &&
              subscriptionType == 'premium'
            " filled light :rules="rules.selectRequired" v-model="form.artist" :items="artistas"
              :loading="artistsLoading" :search-input.sync="searchArtists" color="#4f1087" hide-no-data
              item-value="artista_id" item-text="artista_nome" label="Selecionar Artista" :hint="searchArtists
                ? searchArtists.length < 2
                  ? `Escreva mais ${2 - searchArtists.length} caracteres`
                  : ''
                : 'Escreva pelo menos 3 caracteres'
                " placeholder="Comece a escrever para pesquisar" prepend-inner-icon="mdi-magnify">
              <template v-slot:selection="{ item, index }">
                <div class="tw-flex tw-my-2 tw-items-center" :id="index">
                  <img :src="item.post_image == 'assets/imgs/noImage.jpg' ||
                    item.post_image == 'assets/imgs/no_avatar.jpg'
                    ? 'https://cdn-site.musicpro.live/media/noImage.jpg'
                    : item.post_image
                    " class="tw-object-cover tw-w-8 tw-h-8 tw-rounded-full tw-mr-2" />{{ item.artista_nome }}
                </div>
              </template>
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on" v-bind="attrs" :disabled="item.artista_premium == true ? true : false">
                  <v-list-item-avatar>
                    <img :src="item.post_image == 'assets/imgs/noImage.jpg' ||
                      item.post_image == 'assets/imgs/no_avatar.jpg'
                      ? 'https://cdn-site.musicpro.live/media/noImage.jpg'
                      : item.post_image
                      " class="tw-object-cover tw-w-8 tw-h-8 tw-rounded-full tw-mr-2" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.artista_nome
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="item.artista_premium">
                    <v-chip color="#4f1087" disabled dark>Premium</v-chip>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-autocomplete>
            <div class="tw-relative tw-block tw-w-full tw-text-left" v-if="
              Object.keys(currentUser).length && subscriptionType == 'premium'
            " id="selectHolder">
              <v-select attach="#selectHolder" :items="artistas" label="Selecionar Artista"
                :rules="rules.selectRequired" filled light color="#4f1087" v-model="form.artist"
                :menu-props="{ bottom: true, offsetY: true }" item-value="artista_id">
                <template v-slot:selection="{ item, index }">
                  <div class="tw-flex tw-my-2 tw-items-center" :id="index">
                    <img :src="item.post_image == 'assets/imgs/noImage.jpg' ||
                      item.post_image == 'assets/imgs/no_avatar.jpg'
                      ? 'https://cdn-site.musicpro.live/media/noImage.jpg'
                      : item.post_image
                      " class="tw-object-cover tw-w-8 tw-h-8 tw-rounded-full tw-mr-2" />{{ item.artista_nome }}
                  </div>
                </template>
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on" v-bind="attrs" :disabled="item.artista_premium == true ? true : false">
                    <v-list-item-avatar>
                      <img :src="item.post_image == 'assets/imgs/noImage.jpg' ||
                        item.post_image == 'assets/imgs/no_avatar.jpg'
                        ? 'https://cdn-site.musicpro.live/media/noImage.jpg'
                        : item.post_image
                        " class="tw-object-cover tw-w-8 tw-h-8 tw-rounded-full tw-mr-2" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        item.artista_nome
                      }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="item.artista_premium">
                      <v-chip color="#4f1087" disabled dark>Premium</v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-select>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-justify-between item tw-w-full tw-mb-2">
            <div class="tw-text-xs tw-tracking-widest tw-font-black tw-uppercase tw-font-sans tw-text-gray-700">
              Detalhes
            </div>
          </div>
          <div class="tw-flex tw-items-center item tw-w-full tw-flex-wrap">
            <div class="tw-flex tw-w-full">
              <v-text-field label="Nome" type="text" id="name" name="name" :rules="rules.name"
                v-model="form.buyerDetails.name" dense light color="#4f1087" filled></v-text-field>
            </div>
            <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pr-2">
              <v-text-field label="Email" type="email" id="email" name="email" :rules="rules.required"
                v-model="form.buyerDetails.email" dense light color="#4f1087"
                :disabled="Object.keys(currentUser).length ? true : false" filled></v-text-field>
            </div>
            <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pl-2">
              <v-text-field v-mask="'## #####-####'" :masked="true" label="Celular" :rules="rules.phone"
                validate-on-blur id="cellphone" name="cellphone" type="text" v-model="form.buyerDetails.cellphone" dense
                light color="#4f1087" filled></v-text-field>
            </div>
          </div>
          <div class="tw-flex tw-items-center item tw-w-full tw-flex-wrap">
            <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pr-2">
              <v-select :items="genders" class="tw-cursor-pointer" :rules="rules.selectRequired" label="Sexo" filled
                v-model="form.gender" required item-text="text" item-value="id" dense light color="#4f1087"></v-select>
            </div>
            <div class="tw-flex tw-w-full md:tw-w-6/12 md:tw-pl-2">
              <v-text-field v-mask="'##/##/####'" :masked="true" label="Data de Nascimento" :rules="rules.birthDate"
                validate-on-blur id="birthDate" name="birthDate" type="text" v-model="form.buyerDetails.birthDate" dense
                light color="#4f1087" filled></v-text-field>
            </div>
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-w-full tw-px-5 tw-mt-10">
          <div class="tw-flex tw-items-center tw-justify-between item tw-w-full">
            <div class="tw-text-xs tw-tracking-widest tw-font-black tw-uppercase tw-font-sans tw-text-gray-700">
              Método de Pagamento
            </div>
          </div>
          <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between item tw-w-full tw-mt-5">
            <v-list class="tw-w-full tw-bg-transparent tw-px-0" nav light>
              <v-list-group v-model="accordion.credit_card" prepend-icon="mdi-credit-card" no-action
                @click="showCreditCardForm = true">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="tw-text-left tw-font-sans tw-text-sm tw-font-semibold">Cartão de
                      Crédito</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item class="tw-px-0" v-if="accordion.credit_card">
                  <v-list-item-content>
                    <div id="card-details" class="tw-flex tw-flex-col tw-w-full">
                      <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between item tw-w-full">
                        <div class="tw-flex tw-w-full md:tw-w-7/12 tw-pr-2">
                          <v-text-field label="Nome Completo" :rules="rules.nameCard(showCreditCardForm)"
                            validate-on-blur data-checkout="cardholderName" hint="Como está escrito no cartão"
                            type="text" id="cardholderName" v-model="form.cardDetails.holderName" dense light
                            color="#4f1087" filled onselectstart="return false" onpaste="return false"
                            oncopy="return false" oncut="return false" ondrag="return false"
                            ondrop="return false"></v-text-field>
                        </div>
                        <div class="tw-flex tw-items-center tw-w-full md:tw-w-5/12 md:tw-pl-2">
                          <div class="tw-w-6/12">
                            <v-text-field label="MM" @change="updateMonth" data-checkout="cardExpirationMonth"
                              :rules="rules.requiredCard(showCreditCardForm)" v-mask="'##'" type="text"
                              v-model="form.cardDetails.cardExpirationMonth" id="cardExpirationMonth" dense light
                              color="#4f1087" filled onselectstart="return false" onpaste="return false"
                              oncopy="return false" oncut="return false" ondrag="return false"
                              ondrop="return false"></v-text-field>
                          </div>
                          <div class="tw-px-2 tw-pb-5">
                            <span class="tw-font-sans tw-text-gray-800">/</span>
                          </div>
                          <div class="tw-w-6/12">
                            <v-text-field label="YY" @change="updateYear" v-mask="'##'" type="text"
                              :rules="rules.requiredCard(showCreditCardForm)" data-checkout="cardExpirationYear"
                              v-model="form.cardDetails.cardExpirationYear" id="cardExpirationYear" dense light
                              color="#4f1087" filled onselectstart="return false" onpaste="return false"
                              oncopy="return false" oncut="return false" ondrag="return false"
                              ondrop="return false"></v-text-field>
                          </div>
                        </div>
                        <div class="tw-flex tw-w-7/12 tw-pr-2">
                          <v-text-field label="Número do Cartão" :messages="cardNumberError"
                            :rules="rules.requiredCard(showCreditCardForm)"
                            :error="cardNumberError.length ? true : false" @change="guessPaymentMethod()"
                            v-mask="generateCardNumberMask" hint="Sem pontos ou espaços" type="text"
                            v-model="form.cardDetails.cardNumber" dense light color="#4f1087" filled
                            onselectstart="return false" ondrag="return false" ondrop="return false">
                            <div class="" slot="append">
                              <img :src="'/imgs/creditcards/' +
                                (form.cardDetails.paymentMethodId.length
                                  ? form.cardDetails.paymentMethodId.toLowerCase()
                                  : 'generic') +
                                '.svg'
                                " class="tw-w-10" alt="" />
                            </div>
                          </v-text-field>
                        </div>
                        <div class="tw-flex tw-w-5/12 tw-pl-2">
                          <v-text-field label="CVV" :rules="rules.cvv(showCreditCardForm)" validate-on-blur
                            v-mask="'####'" data-checkout="securityCode" hint="Código de Segurança" type="text"
                            id="securityCode" v-model="form.cardDetails.securityCode" dense light color="#4f1087" filled
                            onselectstart="return false" onpaste="return false" oncopy="return false"
                            oncut="return false" ondrag="return false" ondrop="return false"></v-text-field>
                        </div>
                        <div class="tw-flex tw-w-full" v-if="issuerLoaded">
                          <v-select :items="issuers" label="Banco Emissor"
                            :rules="rules.requiredCard(showCreditCardForm)" name="issuer"
                            v-model="form.cardDetails.issuer" data-checkout="issuer" id="form-checkout__issuer" filled
                            dense item-value="text" light color="#4f1087"></v-select>
                        </div>
                        <DocumentFields :value="{
                          type: form.buyerDetails.identificationType,
                          number: form.buyerDetails.identificationNumber
                        }" :isVisible="showCreditCardForm" @input="identification => {
                          form.buyerDetails.identificationType = identification.type;
                          form.buyerDetails.identificationNumber = identification.number;
                        }" />
                        <AddressFields :value="form.buyerDetails" :rules="rules" @input="newValue => {
                          form.buyerDetails = {
                            ...form.buyerDetails,
                            ...newValue
                          }
                        }" @check-cep="checkCEP" />
                        <div class="tw-w-full tw-mb-5">
                          <v-btn depressed block color="#6819bc" :loading="loading"
                            :disabled="loading || showErrorPayment"
                            class="focus:tw-outline-none focus:tw-bg-purple-400 tw-font-sans tw-text-xs tw-text-white"
                            @click="pagarmeCreditCard()" id="form-checkout__submit" x-large>
                            <span v-if="showErrorPayment">
                              <i class="fas fa-exclamation-triangle tw-mr-2"></i>
                              Error no pagamento - Tente novamente
                            </span>
                            <span v-if="!showErrorPayment">
                              Finalizar Via Cartão de Crédito
                            </span>
                          </v-btn>
                          <small v-if="showErrorPayment" class="tw-text-red-400">
                            Verifique seus dados e os dados do cartão e tente
                            novamente.
                          </small>
                        </div>
                        <input type="hidden" name="paymentMethodId" v-model="form.cardDetails.paymentMethodId"
                          id="paymentMethodId" />
                        <input type="hidden" data-checkout="docType" id="docType" name="docType"
                          v-model="form.buyerDetails.identificationType" />
                        <input type="hidden" data-checkout="cardNumber" id="cardNumber" v-model="cardNumber" />
                        <input type="hidden" name="transactionAmount" id="transactionAmount" v-model="total" />
                        <input type="hidden" name="paymentMethodId" id="paymentMethodId"
                          v-model="form.cardDetails.paymentMethodId" />
                        <input type="hidden" name="description" id="description" />
                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group v-model="accordion.pix" prepend-icon="mdi-qrcode-scan" no-action
                @click="clearCreditCardForm">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      class="tw-text-left tw-font-sans tw-text-sm tw-font-semibold">Pix</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item class="tw-px-0" v-if="accordion.pix">
                  <v-list-item-content>
                    <div id="card-details" class="tw-flex tw-flex-col tw-w-full">
                      <DocumentFields :value="{
                        type: form.buyerDetails.identificationType,
                        number: form.buyerDetails.identificationNumber
                      }" :isVisible="accordion.pix" @input="identification => {
                        form.buyerDetails.identificationType = identification.type;
                        form.buyerDetails.identificationNumber = identification.number;
                      }" />
                      <AddressFields :value="form.buyerDetails" :rules="rules" @input="newValue => {
                        form.buyerDetails = {
                          ...form.buyerDetails,
                          ...newValue
                        }
                      }" @check-cep="checkCEP" />
                      <v-btn depressed block color="#6819bc" :loading="loading" :disabled="loading || showErrorPayment"
                        class="focus:tw-outline-none focus:tw-bg-purple-400 tw-font-sans tw-text-xs tw-text-white"
                        @click="pixPayment()" x-large>
                        <span v-if="showErrorPayment">
                          <i class="fas fa-exclamation-triangle tw-mr-2"></i>
                          Error no pagamento - Tente novamente
                        </span>
                        <span v-if="!showErrorPayment">
                          Finalizar Via Pix
                        </span>
                      </v-btn>
                      <small v-if="showErrorPayment" class="tw-text-red-400">
                        Verifique seus dados e tente novamente.
                      </small>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group v-model="accordion.paypal" prepend-icon="fab fa-paypal" no-action
                @click="clearCreditCardForm">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      class="tw-text-left tw-font-sans tw-text-sm tw-font-semibold">PayPal</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item class="tw-px-0" v-if="accordion.paypal">
                  <v-list-item-content>
                    <div id="paypal-button" class="tw-flex tw-flex-col tw-w-full">
                      <v-btn depressed block color="#003087" :loading="loading" :disabled="loading"
                        class="focus:tw-outline-none tw-font-sans tw-text-xs tw-text-white" @click="createPayPalOrder"
                        x-large>
                        <span>
                          <i class="fab fa-paypal tw-mr-2"></i>
                          Pagar com PayPal
                        </span>
                      </v-btn>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </div>
        </div>
      </v-form>
      <div class="tw-w-full tw-rounded-2xl tw-bg-gray-200 tw-mt-8 tw-shadow-lg" v-if="page == 2">
        <div class="tw-flex tw-flex-col tw-w-full tw-p-5">
          <div class="tw-w-full tw-text-center">
            <i class="far fa-check-circle tw-text-5xl tw-mb-2 tw-text-green-500"></i>
            <div class="tw-text-xs tw-tracking-widest tw-font-black tw-uppercase tw-font-sans tw-text-gray-700 tw-mb-2">
              Pedido Efetuado
            </div>
            <div class="tw-text-xs tw-font-sans tw-text-gray-700 tw-mb-4">
              Estamos processando seu pagamento. <br />
              Você pode acompanhar o status do seu pedido na sua conta:
              <a href="https://musicpro.live/minha-conta/pedidos">click no link</a>
            </div>
            <v-btn depressed block color="#6819bc"
              class="focus:tw-outline-none focus:tw-bg-purple-400 tw-font-sans tw-text-xs" :href="subscriptionType == 'backstage'
                ? route('backstage.index', artist.artista_url)
                : '/admin'
                " id="form-checkout__submit" x-large>
              Voltar
            </v-btn>
          </div>
        </div>
      </div>
      <div class="tw-w-full tw-rounded-2xl tw-bg-gray-200 tw-mt-8 tw-shadow-lg" v-if="page == 3">
        <div class="tw-flex tw-flex-col tw-w-full tw-p-5">
          <div class="tw-w-full tw-text-center">
            <i class="far fa-check-circle tw-text-5xl tw-mb-2 tw-text-green-500"></i>
            <div class="tw-text-xs tw-tracking-widest tw-font-black tw-uppercase tw-font-sans tw-text-gray-700 tw-mb-2">
              Pedido Efetuado
            </div>
            <div class="tw-text-xs tw-font-sans tw-text-gray-700 tw-mb-4">
              Pague o código pix abaixo no app do seu banco. <br />
              Você será avisado por e-mail assim que a transação for concluída.
            </div>
            <div class="tw-flex tw-w-full tw-justify-center tw-items-center">
              <img :src="`data:image/jpeg;base64,${form.pix_base64}`" style="max-width: 300px" />
            </div>
            <div class="tw-py-3 tw-text-center tw-w-full">
              <input type="text" id="hash" class="tw-hidden" :value="form.pix" />
              <div class="tw-text-xs tw-font-sans tw-text-gray-700 tw-mb-4 tw-truncate">
                {{ form.pix }}
              </div>
              <v-btn outlined color="#6819bc" @click="copiarTexto()" class="tw-font-sans tw-text-xs">
                Copiar
              </v-btn>
            </div>
            <v-btn depressed block color="#6819bc"
              class="focus:tw-outline-none focus:tw-bg-purple-400 tw-font-sans tw-text-xs"
              :href="route('minha-conta.pedidos')" id="form-checkout__submit" x-large>
              MEUS PEDIDOS
            </v-btn>
          </div>
        </div>
      </div>
      <v-snackbar v-if="(snackBar.visible = true)" bottom :timeout="3000">
        {{ snackBar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackBar.visible = false" class="focus:tw-outline-none">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </section>
</template>

<script>
import Layout from "@/Shared/NoMenu";
import { mask } from "vue-the-mask";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import DocumentFields from '@/components/checkout/form/DocumentFields.vue'
import AddressFields from '@/components/checkout/form/AddressFields.vue'


Vue.use(VueReCaptcha, { siteKey: '6LcbKeUpAAAAAAdJJpt25_Ftzc1wAs10AEWvxc45' })

export default {
  components: {
    AddressFields,
    DocumentFields
  },
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  metaInfo() {
    return {
      title: "MusicPro - Checkout"
    };
  },
  directives: { mask },
  props: [
    "artists",
    "artist",
    "productCost",
    "subscriptionType",
    "serviceUser",
    "discountCoupons",
    "success",
  ],
  data() {
    return {
      showCreditCardForm: false,
      couponInput: "",
      showErrorPayment: false,
      discount: "",
      couponApplied: null,
      page: 1,
      loading: false,
      authenticated: false,
      artistsLoading: false,
      artistas: "",
      laravel_token: $("meta[name=csrf-token]").attr("content"),
      token: "",
      created_customer: false,
      customer_id: "",
      genders: [
        { id: "male", text: "Masculino" },
        { id: "female", text: "Feminino" }
      ],
      autoComplete: [
        { id: "AC" },
        { id: "AL" },
        { id: "AP" },
        { id: "AM" },
        { id: "BA" },
        { id: "BH" },
        { id: "CE" },
        { id: "DF" },
        { id: "ES" },
        { id: "GO" },
        { id: "MA" },
        { id: "MT" },
        { id: "MS" },
        { id: "MG" },
        { id: "PA" },
        { id: "PB" },
        { id: "PR" },
        { id: "PE" },
        { id: "PI" },
        { id: "RJ" },
        { id: "RN" },
        { id: "RS" },
        { id: "RO" },
        { id: "RR" },
        { id: "SC" },
        { id: "SP" },
        { id: "SE" },
        { id: "TO" }
      ],
      accordion: {
        credit_card: false,
        pix: false,
        paypal: false,
        coupon: false
      },
      snackBar: {
        visible: false,
        message: ""
      },
      rules: {
        selectRequired: [v => !!v || "Campo obrigatório"],
        requiredCard: function (isVisible) {
          return [
            val =>
              (isVisible ? (val || "").length > 0 : true) || "Campo obrigatório"
          ];
        },
        required: [v => !!v || "Campo obrigatório"],
        nameCard: function (isVisible) {
          return [
            v =>
              isVisible ? v && v.length > 5 : true || "Pelo menos 5 caracteres"
          ];
        },
        name: [v => (v && v.length > 5) || "Pelo menos 5 caracteres"],
        phone: [v => (v && v.length >= 13) || "Preencha corretamente"],
        birthDate: [v => (v && v.length >= 10) || "Preencha corretamente"],
        zipCode: function(isVisible) {
          return [v => isVisible ? (v && v.length >= 8) || "Mínimo de 8 caracteres" : true];
        },
        cvv: function (isVisible) {
          return [
            v =>
              isVisible ? v && v.length >= 3 : true || "Mínimo 3 caracteres"
          ];
        }
      },
      form: {
        valid: true,
        artist: "",
        buyerDetails: {
          name: "",
          email: "",
          cellphone: "",
          birthDate: "",
          identificationType: "CPF",
          identificationNumber: "",
          gender: "male",
          zipCode: "",
          uf: "",
          city: "",
          district: "",
          street: "",
          streetNumber: ""
        },
        cardDetails: {
          holderName: "",
          cardExpirationMonth: "",
          cardExpirationYear: "",
          cardNumber: "",
          securityCode: "",
          paymentMethodId: "",
          issuer: "",
          installments: 1,
          token: ""
        },
        pix: "",
        pix_base64: ""
      },
      searchArtists: "",
      password: "",
      cardNumberError: "",
      installments: [],
      issuerLoaded: false,
      issuers: [],
      identificationType: ["CPF", "CNPJ"],
      installments: [],
      amexCardMask: "#### ###### #####",
      dinersCardMask: "#### ###### ####",
      otherCardMask: "#### #### #### ####",
      typingTimeout: 0
    };
  },
  computed: {
    generateCardNumberMask() {
      if (this.form.cardDetails.paymentMethodId === "amex") {
        return this.amexCardMask;
      }
      if (this.form.cardDetails.paymentMethodId === "diners") {
        return this.dinersCardMask;
      } else {
        return this.otherCardMask;
      }
    },
    identificationMask() {
      if (this.form.buyerDetails.identificationType == "CPF") {
        return "###.###.###-##";
      }
      return "##.###.###/####-##";
    },
    identificationNumber() {
      return this.form.buyerDetails.identificationNumber
        .split(".")
        .join("")
        .replace("-", "")
        .replace("/", "");
    },
    cardNumber() {
      return this.form.cardDetails.cardNumber.replace(/\s/g, "");
    },
    productName() {
      if (this.subscriptionType == "backstage") {
        return "Assinatura " + this.artist.artista_nome + " x 1";
      } else {
        return "Assinatura Premium x 1";
      }
    },
    total() {
      let total = this.productCost / 100;

      if (this.discount > 0) {
        total -= this.discount;
      }

      return parseFloat(total.toFixed(1));
    },
    displayDiscount() {
      return (
        "R$" +
        parseFloat(this.discount)
          .toFixed(2)
          .toString()
          .replace(".", ",")
      );
    },
    displayPrice() {
      return (
        "R$" +
        parseFloat(this.productCost / 100)
          .toFixed(2)
          .toString()
          .replace(".", ",")
      );
    },
    displayTotal() {
      let price = (this.productCost / 100).toFixed(2);

      if (this.discount > 0) {
        price = (parseFloat(price) - parseFloat(this.discount)).toFixed(2);
      }

      price = price.replace(".", ",");

      return "R$" + price;
    }
  },
  methods: {
    async createPayPalOrder() {
      const vm = this;
      if (!this.$refs.paymentForm.validate()) {
        this.snackBar.message = "Por favor corrija os campos";
        this.snackBar.visible = true;
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post('/api/paypal/create-order', {
          amount: this.total,
          product_name: this.productName,
          buyer_details: this.form.buyerDetails,
          artist_id: this.artist ? this.artist.artista_id : this.form.artist,
          subscription_type: this.subscriptionType,
          user_id: Object.keys(this.currentUser).length ? this.currentUser.id : this.serviceUser.id
        });

        if (response.data.approval_url) {
          await vm.createOrder(response.data.order_id, 'pending', 'paypal');
          window.location.href = response.data.approval_url;
        }
      } catch (error) {
        this.loading = false;
        this.snackBar.message = "Ocorreu um erro ao processar seu pagamento";
        this.snackBar.visible = true;
      }
    },
    clearCreditCardForm() {
      this.showCreditCardForm = false;
      this.form.cardDetails = {
        holderName: "",
        cardExpirationMonth: "",
        cardExpirationYear: "",
        cardNumber: "",
        securityCode: "",
        paymentMethodId: "",
        issuer: "",
        installments: 1,
        token: ""
      };
    },
    applyCoupon() {
      const matchingCoupon = this.discountCoupons.find(
        coupon =>
          coupon.coupon_code.toLowerCase() === this.couponInput.toLowerCase()
      );

      if (matchingCoupon) {
        this.discount = matchingCoupon.discount_amount;
        this.couponApplied = true;
      } else {
        this.couponApplied = false;
        this.discount = "";
      }
    },
    copiarTexto() {
      if (!navigator.clipboard) {
        let textoCopiado = document.getElementById("hash");
        textoCopiado.select();
        textoCopiado.setSelectionRange(0, 99999);
        document.execCommand("copy");
      } else {
        navigator.clipboard.writeText(this.form.pix).then(() => {
          this.snackBar.message = "Código copiado!";
          this.snackBar.visible = true;
        });
      }
    },
    validateDoc() {
      const cleanNumber = this.identificationNumber.replace(/[^\d]/g, "");

      if (this.form.buyerDetails.identificationType == "CPF") {
        if (cleanNumber.length !== 11) {
          return "O CPF precisa ter 11 dígitos";
        }

        if (!this.isValidCPF(cleanNumber)) {
          return "CPF inválido";
        }
      } else if (this.form.buyerDetails.identificationType == "CNPJ") {
        if (cleanNumber.length !== 14) {
          return "O CNPJ precisa ter 14 dígitos";
        }
        if (!this.isValidCNPJ(cleanNumber)) {
          return "CNPJ inválido";
        }
      } else {
        return "Tipo de documento não suportado";
      }

      return true;
    },
    isValidCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");

      if (
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
      ) {
        return false;
      }

      let sum = 0;
      let remainder;

      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }

      remainder = (sum * 10) % 11;

      if (remainder === 10 || remainder === 11) {
        remainder = 0;
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false;
      }

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }

      remainder = (sum * 10) % 11;

      if (remainder === 10 || remainder === 11) {
        remainder = 0;
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        return false;
      }

      return true;
    },
    isValidCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, "");

      if (
        cnpj.length !== 14 ||
        cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999"
      ) {
        return false;
      }

      let sum = 0;
      let length = cnpj.length - 2;
      let numbers = cnpj.substring(0, length);
      let digits = cnpj.substring(length);
      let position = length - 7;

      for (let i = length; i >= 1; i--) {
        sum += parseInt(numbers.charAt(length - i)) * position--;
        if (position < 2) {
          position = 9;
        }
      }

      let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

      if (result !== parseInt(digits.charAt(0))) {
        return false;
      }

      length += 1;
      numbers = cnpj.substring(0, length);
      sum = 0;
      position = length - 7;

      for (let i = length; i >= 1; i--) {
        sum += parseInt(numbers.charAt(length - i)) * position--;
        if (position < 2) {
          position = 9;
        }
      }

      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

      if (result !== parseInt(digits.charAt(1))) {
        return false;
      }

      return true;
    },
    validateInstallments() {
      if (this.form.cardDetails.installments.toString().length > 0) {
        return true;
      }

      return "Campo obrigatório";
    },
    updateMonth(event) {
      const value = event;
      if (parseInt(value) > 12) {
        this.form.cardDetails.cardExpirationMonth = 12;
      }
      if (value.length == 1) {
        this.form.cardDetails.cardExpirationMonth =
          "0" + this.form.cardDetails.cardExpirationMonth;
      }
      if (value == "0" || value == "00") {
        this.form.cardDetails.cardExpirationMonth = "";
      }
      if (
        parseInt(this.form.cardDetails.cardExpirationYear) ==
        parseInt(
          new Date()
            .getFullYear()
            .toString()
            .substr(-2)
        )
      ) {
        const minMonth = new Date().getMonth();
        if (parseInt(value) < minMonth) {
          this.form.cardDetails.cardExpirationMonth = "";
        }
      }
      this.$forceUpdate();
    },
    updateYear(event) {
      const value = event;
      if (
        parseInt(value) <
        parseInt(
          new Date()
            .getFullYear()
            .toString()
            .substr(-2)
        )
      ) {
        this.form.cardDetails.cardExpirationYear = "";
      }
      if (value.length == 1) {
        this.form.cardDetails.cardExpirationYear =
          "0" + this.form.cardDetails.cardExpirationYear;
      }
      if (value == "0" || value == "00") {
        this.form.cardDetails.cardExpirationYear = "";
      }
      if (
        parseInt(value) ==
        parseInt(
          new Date()
            .getFullYear()
            .toString()
            .substr(-2)
        )
      ) {
        const minMonth = new Date().getMonth();
        if (parseInt(this.form.cardDetails.cardExpirationMonth) < minMonth) {
          this.form.cardDetails.cardExpirationMonth = "";
        }
      }
      this.$forceUpdate();
    },
    register(name, email, password) {
      const vm = this;
      var data = JSON.stringify({
        nome: name,
        email: email,
        senha: password,
        senhaConfirmacao: password
      });

      var config = {
        method: "post",
        url: "https://api.musicpro.live:55002/api/usuario/register",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        },
        data: data
      };
      axios(config)
        .then(function (response) {
          vm.authenticate(email, password);
        })
        .catch(function (error) {
          vm.authenticate(email, password);
        });
    },
    authenticate(email, password) {
      const vm = this;
      var data = JSON.stringify({
        email: email,
        senha: password
      });

      var config = {
        method: "post",
        url: "https://api.musicpro.live:55002/api/usuario/autenticar",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        },
        data: data
      };

      axios(config).then(function (response) {
        vm.token = response.data.token;
        vm.updatePaymentToken(response.data.token);
      });
    },
    updatePaymentToken(token) {
      axios.post("/api/user/update-payment-token", {
        user: Object.keys(this.currentUser).length
          ? this.currentUser.id
          : this.serviceUser.id,
        payment_token: token
      });
    },
    createCustomer(user_id) {
      this.showErrorPayment = false;
      var data = JSON.stringify({
        name: this.form.buyerDetails.name,
        email: this.form.buyerDetails.email,
        code: this.serviceUser
          ? user_id + "_serviceUser_" + this.makeid(5)
          : user_id +
          (this.$page.props.config.pagarme.sandbox
            ? "_" + this.makeid(5)
            : ""),
        document: this.form.buyerDetails.identificationNumber,
        document_type: this.form.buyerDetails.identificationType,
        type: "individual",
        gender: this.form.buyerDetails.gender,
        address: {
          country: "BR",
          state: this.form.buyerDetails.uf,
          city: this.form.buyerDetails.city,
          zip_code: this.form.buyerDetails.zipCode,
          street: this.form.buyerDetails.street,
          number: this.form.buyerDetails.streetNumber,
          neighborhood: this.form.buyerDetails.district,
          complement: ""
        },
        phones: {
          home_phone: "",
          mobile_phone: this.form.buyerDetails.cellphone
        },
        birthdate: this.form.buyerDetails.birthDate
      });

      let url = "https://api.musicpro.live:55002/api/pagarme/";
      if (this.$page.props.config.pagarme.sandbox) {
        url = url + "sandbox/customers";
      } else {
        url = url + "customers";
      }

      var config = {
        method: "post",
        url: url,
        headers: {
          "x-access-token": this.token,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        },
        data: data
      };

      const vm = this;
      axios(config).then(function (res) {
        vm.customer_id = res.data.id;
        axios
          .post("/api/pagarme/customer/" + user_id, {
            token: vm.laravel_token,
            pagarme_customer_id: res.data.id
          })
          .then(res => {
            vm.created_customer = true;
            vm.pagarmeCreditCard();
          })
          .catch(err => {
            console.log("error customer", err);
            vm.snackBar.visible = true;
            vm.loading = false;
            vm.snackBar.message = "Ocorreu um erro ao processar seu pagamento";
            vm.showErrorPayment = true;
            if (vm.showErrorPayment) {
              setTimeout(() => {
                vm.showErrorPayment = false;
              }, 5000);
            }
          });
      });
    },
    async pagarmeCreditCard() {
      await this.$recaptchaLoaded()

      const tokenReCaptcha = await this.$recaptcha('login')

      this.loading = true;
      this.snackBar.visible = false;
      this.showErrorPayment = false;

      if (!this.$refs.paymentForm.validate()) {
        this.loading = false;
        this.snackBar.message = "Por favor corrija os campos";
        this.snackBar.visible = true;
        return;
      }

      if (!this.created_customer) {
        try {
          this.createCustomer(
            Object.keys(this.currentUser).length
              ? this.currentUser.id
              : this.serviceUser.id
          );
        } catch (error) {
          console.log("error customer: ", error);
          this.snackBar.message = "Ocorreu um erro ao processar seu pagamento";
          this.snackBar.visible = true;
          this.loading = false;
          return;
        }
      }
      let total = this.total.toFixed(2).replace(".", "");
      total = parseInt(total);

      var data = JSON.stringify({
        customer_id: this.customer_id,
        metadata: {
          artista_id: this.form.artist
        },
        items: [
          {
            amount: total,
            description: this.artist
              ? "Assinatura Backstage"
              : "Assinatura MPro Premium",
            quantity: 1
          }
        ],
        payments: [
          {
            payment_method: "credit_card",
            credit_card: {
              recurrence: false,
              installments: 1,
              statement_descriptor: this.artist
                ? "As MPro Back"
                : "As MPro Prem",
              card: {
                number: this.form.cardDetails.cardNumber,
                holder_name: this.form.cardDetails.holderName,
                exp_month: this.form.cardDetails.cardExpirationMonth,
                exp_year: this.form.cardDetails.cardExpirationYear,
                cvv: this.form.cardDetails.securityCode,
                billing_address: {
                  number: this.form.buyerDetails.streetNumber,
                  street: this.form.buyerDetails.street,
                  neighborhood: this.form.buyerDetails.district,
                  zip_code: this.form.buyerDetails.zipCode,
                  city: this.form.buyerDetails.city,
                  state: this.form.buyerDetails.uf,
                  country: "BR"
                }
              }
            }
          }
        ],
        'g-recaptcha-response': tokenReCaptcha
      });

      let url = "https://api.musicpro.live:55002/api/pagarme/";
      if (this.$page.props.config.pagarme.sandbox) {
        url = url + "sandbox/orders";
      } else {
        url = url + "orders";
      }

      var config = {
        method: "post",
        url: url,
        headers: {
          "x-access-token": this.token,
          "Content-Type": "application/json"
        },
        data: data
      };

      const vm = this;

      axios(config)
        .then(function (res) {
          const status = res.data.status;
          console.log(status);
          vm.createOrder(res.data.id, status, "credit_card");
        })
        .catch(function (error) {
          vm.loading = false;
          vm.snackBar.message = "Ocorreu um erro ao processar seu pagamento";
          vm.snackBar.visible = true;
          vm.showErrorPayment = true;
          if (vm.showErrorPayment) {
            setTimeout(() => {
              vm.showErrorPayment = false;
            }, 5000);
          }
        });
    },
    makePixPayment() {
      this.loading = true;
      this.snackBar.visible = false;
      this.showErrorPayment = false;

      var data = JSON.stringify({
        payment_method_id: "pix",
        transaction_amount: this.total,
        description: "",
        payer: {
          email: this.form.buyerDetails.email,
          identification: {
            type: this.form.buyerDetails.identificationType,
            number: this.identificationNumber
          }
        },
        metadata: {
          artista_id: this.form.artist
        }
      });

      let url = "https://api.musicpro.live:55002/api/process_payment_pix/";
      if (this.$page.props.config.mercadopago.status == "local") {
        url = url + "sandbox";
      }


      console.log("Token antes da requisição:", this.token); 


      var config = {
        method: "post",
        url: url,
        headers: {
          "x-access-token": this.token,
          "Content-Type": "application/json"
        },
        data: data
      };

      const vm = this;
      axios(config)
        .then(function (response) {
          const status = response.data.status;
          vm.form.pix =
            response.data.point_of_interaction.transaction_data.qr_code;
          vm.form.pix_base64 =
            response.data.point_of_interaction.transaction_data.qr_code_base64;
          vm.createOrder(response.data.id, status, "pix");
        })
        .catch(function (error) {
          vm.loading = false;
          vm.snackBar.message = "Ocorreu um erro ao processar seu pagamento";
          vm.snackBar.visible = true;
          vm.showErrorPayment = true;
          if (vm.showErrorPayment) {
            setTimeout(() => {
              vm.showErrorPayment = false;
            }, 5000);
          }
        });
    },
    makePayment() {
      var data = JSON.stringify({
        token: this.form.cardDetails.token,
        issuerId: this.form.cardDetails.issuer,
        paymentMethodId: this.form.cardDetails.paymentMethodId,
        transactionAmount: this.total,
        installments: this.form.cardDetails.installments,
        description: "",
        payer: {
          email: this.form.buyerDetails.email,
          identification: {
            type: this.form.buyerDetails.identificationType,
            number: this.identificationNumber
          }
        }
      });

      let url = "https://api.musicpro.live:55002/api/process_payment/";
      if (this.$page.props.config.mercadopago.status == "local") {
        url = url + "sandbox";
      }

      var config = {
        method: "post",
        url: url,
        headers: {
          "x-access-token": this.token,
          "Content-Type": "application/json"
        },
        data: data
      };

      const vm = this;
      axios(config)
        .then(function (response) {
          const status = response.data.status;
          if (status == "approved" || status == "in_process") {
            vm.createOrder(response.data.id, status, "credit_card");
          } else {
            vm.loading = false;
            vm.snackBar.message = response.data.message;
            vm.snackBar.visible = true;
            vm.form.cardDetails.token = "";
          }
        })
        .catch(function (error) {
          vm.loading = false;
          vm.snackBar.message = vm.errorResponses(error.data.message);
          vm.snackBar.visible = true;
          vm.form.cardDetails.token = "";
        });
    },
    async createOrder(transaction_id, status, payment_method) {
      this.showErrorPayment = false;
      const vm = this;
      await axios
        .post("/api/orders", {
          transaction_id: transaction_id,
          artista_id: vm.artist ? vm.artist.artista_id : vm.form.artist,
          buyer_artista_id: vm.artist ? null : vm.form.artist,
          user_uid: Object.keys(vm.currentUser).length
            ? vm.currentUser.mp_id
            : vm.serviceUser.mp_id,
          fullname: Object.keys(vm.currentUser).length
            ? vm.currentUser.name
            : vm.form.buyerDetails.name,
          email: vm.form.buyerDetails.email,
          status: status,
          type: "subscription",
          amount: vm.total,
          installments: vm.form.cardDetails.installments,
          payment_method: payment_method,
          doc_number: vm.form.buyerDetails.identificationNumber,
          pix: vm.form.pix,
          pix_base64: vm.form.pix_base64,
          description: vm.artist ? "Assinatura Backstage" : "Assinatura Premium"
        })
        .then(res => {
          vm.loading = false;
          if (payment_method == "pix") {
            return (vm.page = 3);
          }
          if (payment_method == "paypal") {
            return
          }
          vm.page = 2;
        })
        .catch(err => {
          console.error("Erro no pagamento: new", err.message);

          vm.loading = false;
          vm.snackBar.message = "Ocorreu um erro ao processar seu pagamento";
          vm.snackBar.visible = true;
          vm.showErrorPayment = true;
          if (vm.showErrorPayment) {
            setTimeout(() => {
              vm.showErrorPayment = false;
            }, 5000);
          }
        });
    },
    errorResponses(error) {
      switch (error) {
        case "cc_rejected_bad_filled_card_number":
          return "Revise o número do cartão.";
          break;

        case "cc_rejected_bad_filled_date":
          return "Revise a data de vencimento.";
          break;

        case "cc_rejected_bad_filled_other":
          return "Revise os dados.";
          break;

        case "cc_rejected_bad_filled_security_code":
          return "Revise o código de segurança do cartão.";
          break;
        case "cc_rejected_blacklist":
          return "Não pudemos processar seu pagamento.";
          break;

        case "cc_rejected_call_for_authorize":
          return "Você deve autorizar ao Banco Emissor o pagamento do valor ao Mercado Pago.";
          break;

        case "cc_rejected_card_disabled":
          return "Ligue para o Banco Emissor para ativar seu cartão. O telefone está no verso do seu cartão.";
          break;

        case "cc_rejected_card_error":
          return "Não conseguimos processar seu pagamento.";
          break;

        case "cc_rejected_duplicated_payment":
          return "Você já efetuou um pagamento com esse valor. Caso precise pagar novamente, utilize outro cartão ou outra forma de pagamento.";
          break;

        case "cc_rejected_high_risk":
          return "Seu pagamento foi recusado.";
          break;

        case "cc_rejected_insufficient_amount":
          return "O cartão escolhido possui saldo insuficiente.";
          break;

        case "cc_rejected_invalid_installments":
          return "O Banco Emissor não processa pagamentos em parcelas.";
          break;

        case "cc_rejected_max_attempts":
          return "Você atingiu o limite de tentativas permitido.";
          break;

        case "cc_rejected_other_reason":
          return "Banco Emissor não processou o pagamento.";
          break;

        default:
          return "Banco Emissor não processou o pagamento.";
          break;
      }
    },
    guessPaymentMethod() {
      if (this.form.cardDetails.cardNumber.length >= 6) {
        this.issuerLoaded = false;
        this.form.cardDetails.issuer = "";
        let bin = this.form.cardDetails.cardNumber
          .replace(/\s/g, "")
          .substring(0, 6);
        window.Mercadopago.getPaymentMethod(
          {
            bin: bin
          },
          (status, res) => {
            this.setPaymentMethod(status, res);
          }
        );
      } else {
        this.issuerLoaded = false;
        this.form.cardDetails.issuer = "";
        this.form.cardDetails.paymentMethodId = "";
      }
    },
    setPaymentMethod(status, response) {
      if (status == 200) {
        let paymentMethod = response[0];
        this.form.cardDetails.paymentMethodId =
          paymentMethod.name == "American Express"
            ? "Amex"
            : paymentMethod.name;
        this.cardNumberError = "";

        this.getIssuers(paymentMethod.id);
      } else {
        this.cardNumberError =
          response.message == "payment method not found"
            ? "Cartão não suportado"
            : response.message;
      }
    },
    getIssuers(paymentMethodId) {
      window.Mercadopago.getIssuers(paymentMethodId, (status, res) => {
        this.setIssuers(status, res);
      });
    },
    setIssuers(status, response) {
      if (status == 200) {
        const vm = this;
        response.forEach(issuer => {
          vm.issuers.push({
            text: issuer.name,
            value: issuer.id
          });
        });
        this.issuerLoaded = true;

        // this.getInstallments(
        //     this.form.cardDetails.paymentMethodId,
        //     this.total,
        //     this.form.cardDetails.issuer
        // );
      } else {
        alert(`issuers method info error: ${response}`);
      }
    },
    getInstallments(paymentMethodId, transactionAmount, issuerId) {
      window.Mercadopago.getInstallments(
        {
          payment_method_id: paymentMethodId,
          amount: transactionAmount,
          issuer_id: parseInt(issuerId)
        },
        (status, response) => {
          this.setInstallments(status, response);
        }
      );
    },
    setInstallments(status, response) {
      if (status == 200) {
        const vm = this;
        response[0].payer_costs.forEach(payerCost => {
          vm.installments.push({
            text: payerCost.recommended_message,
            value: payerCost.installments
          });
        });
        this.form.cardDetails.installments = 1;
      } else {
        alert(`installments method info error: ${response}`);
      }
    },
    pixPayment() {
      let $form = document.getElementById("paymentForm");
      if (this.$refs.paymentForm.validate()) {
        this.loading = true;

        this.makePixPayment();
      }
    },
    getCardToken() {
      let $form = document.getElementById("paymentForm");
      if (this.$refs.paymentForm.validate()) {
        this.loading = true;
        window.Mercadopago.createToken($form, (status, res) => {
          this.setCardTokenAndPay(status, res);
          return;
        });
        return false;
      }
    },
    setCardTokenAndPay(status, response) {
      if (status == 200 || status == 201) {
        this.form.cardDetails.token = response.id;
        this.makePayment();
      } else {
        this.loading = false;
        const code = response.cause[0].code;
        let message = "";
        this.form.cardDetails.token = "";
        switch (code) {
          case "E301":
            message = "Número do cartão inválido. Digite novamente.";
            break;

          case "205":
            message = "Digite o número do seu cartão.";
            break;

          case "208":
            message = "Escolha um mês.";
            break;

          case "209":
            message = "Escolha um ano.";
            break;

          case "212":
            message = "Informe seu documento.";
            break;

          case "213":
            message = "Informe seu documento.";
            break;

          case "214":
            message = "Informe seu documento.";
            break;

          case "220":
            message = "Informe seu banco emissor.";
            break;

          case "221":
            message = "Digite o nome e sobrenome.";
            break;

          case "224":
            message = "Digite o código de segurança.";
            break;

          case "E302":
            message = "Confira o código de segurança.";
            break;

          case "316":
            message = "Por favor, digite um nome válido.";
            break;

          case "322":
            message = "Confira seu documento.";
            break;

          case "323":
            message = "Confira seu documento.";
            break;

          case "324":
            message = "Confira seu documento.";
            break;

          case "325":
            message = "Confira a data.";
            break;

          case "326":
            message = "Confira a data.";
            break;

          default:
            message = "Recarregue a página e tente novamente.";
            break;
        }
        this.snackBar.message = message;
        this.snackBar.visible = true;
      }
    },
    checkCEP() {
      var cep = this.form.buyerDetails.zipCode;
      var vm = this;
      $.ajax({
        type: "get",
        url: `https://viacep.com.br/ws/${cep}/json/`,
        success: function (response) {
          if (!response.erro) {
            vm.form.buyerDetails.uf = response.uf;
            vm.form.buyerDetails.city = response.localidade;
            vm.form.buyerDetails.district = response.bairro;
            vm.form.buyerDetails.street = response.logradouro;
          }
        }
      });
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    async getArtists(val) {
      if (this.typingTimeout > 0) {
        clearTimeout(this.typingTimeout);
      }
      this.typingTimeout = setTimeout(async () => {
        this.artistsLoading = true;
        try {
          const response = await axios.get(`/api/artists/search?q=${val}`);
          this.artistas = response.data;
          this.artistsLoading = false;
        } catch (error) {
          console.log(error);
          this.artistsLoading = false;
        }
      }, 500);
    }
  },
  created() {
    this.form.buyerDetails.email = this.currentUser.email;
    this.artistas = this.artists;
    if (this.success) {
      this.page = 2;
    }
  },
  mounted() {
    let mercadopagoScript = document.createElement("script");
    mercadopagoScript.setAttribute(
      "src",
      "https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js"
    );
    document.head.appendChild(mercadopagoScript);

    if (Object.keys(this.currentUser).length) {
      if (this.currentUser.pagarme_customer_id) {
        this.created_cproductCostustomer = true;
        this.customer_id = this.currentUser.pagarme_customer_id;
      }
      if (!this.currentUser.payment_token) {
        this.register(
          this.currentUser.name,
          this.currentUser.email,
          this.currentUser.mp_id
        );
      } else {
        this.authenticate(this.currentUser.email, this.currentUser.mp_id);
      }
    } else {
      if (!this.serviceUser.payment_token) {
        this.register(
          "Service Account",
          this.serviceUser.email,
          this.serviceUser.mp_id
        );
      } else {
        this.authenticate(this.serviceUser.email, this.serviceUser.mp_id);
      }
    }

    setTimeout(() => {
      window.Mercadopago.setPublishableKey(
        this.$page.props.config.mercadopago.status == "local"
          ? this.$page.props.config.mercadopago.sandbox_public_key
          : this.$page.props.config.mercadopago.public_key
      );
    }, 2000);
  },
  watch: {
    searchArtists(val) {
      if (this.artistsLoading) return;

      if (val ? val.length >= 3 : false) {
        this.getArtists(val);
      }
    }
  }
};
</script>

<style>
#cardholderName {
  text-transform: uppercase !important;
}
</style>
